module.exports = __webpack_public_path__ + "35aab35f1b1ae6c2e5419766abf7e0ee.otf";


//////////////////
// WEBPACK FOOTER
// ./www/app/content/themes/rikssalsstiftelsen/static/fonts/Alegreya-BoldItalic.otf
// module id = 19
// module chunks = 0